import { UNLIMITED_TIER } from "@chesshotel/constants";
import { useUser } from "../../../ducks/user";
import { useMembership } from "../../../ducks/membership";
import { useLeagues } from "../../../ducks/leagues";
import { useLobby } from "../../../ducks/lobby";
import { INITIAL_LEAGUE_GAMES } from "@chesshotel/constants";
import dynamic from "next/dynamic";
import { useSignIn } from "@/src/ducks/signIn";
const SeasonPopup = dynamic(() => import("./SeasonPopup"));
const LeagueGamePopup = dynamic(() => import("./LeagueGamePopup"));
const RegisterPopup = dynamic(() => import("./RegisterPopup"));
const NotActivatedPopup = dynamic(() => import("./NotActivatedPopup"));
const FBUpgradePopup = dynamic(() => import("./FBUpgradePopup"));

export default function LobbyPopups() {
  // const [didShow, setDidShow] = useState(false);
  const { fbNeedsUpgrade } = useSignIn();
  const { isGuest, emailNotActivated } = useUser();
  const { tier, leagueGames } = useMembership();
  const { hasPlayedCurrentSeason, didViewSeasonPopup, hasLastSeason } =
    useLeagues();
  const { leaguePlay } = useLobby();

  return (
    <>
      {!hasPlayedCurrentSeason && hasLastSeason && !didViewSeasonPopup && (
        <SeasonPopup />
      )}
      {leaguePlay && isGuest && leagueGames <= 0 && <RegisterPopup />}
      {!isGuest &&
        leaguePlay &&
        leagueGames <= 0 &&
        tier !== UNLIMITED_TIER && <LeagueGamePopup />}
      {!isGuest &&
        leaguePlay &&
        emailNotActivated &&
        leagueGames <= INITIAL_LEAGUE_GAMES - 11 && <NotActivatedPopup />}
      {fbNeedsUpgrade && <FBUpgradePopup />}
    </>
  );
}
